import React from "react";
import { Input, Row, Col, Typography, Card, Form } from "antd";
import NeedHelpIcon from "../NeedHelpIcon/NeedHelpIcon";

const { Title } = Typography;

const CompanyContactInformation = () => {
  return (
    <Card style={{ width: "100%" }}>
      <Row style={{ justifyContent: "space-between", width: "100%" }}>
        <Col>
          <Title level={3}>Kontaktinformasjon</Title>
        </Col>
        <Col>
          <NeedHelpIcon />
        </Col>
      </Row>

      <Title level={5}>Kontaktperson</Title>
      <Row gutter={24}>
        <Col md={12} sm={24} xs={24}>
          <Form.Item
            label="Fornavn"
            name="first_name"
            rules={[
              {
                required: true,
                message: "Skriv inn fornavn",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col md={12} sm={24} xs={24}>
          <Form.Item
            label="Etternavn"
            name="last_name"
            rules={[
              {
                required: true,
                message: "Skriv inn etternavn",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col md={8} sm={24} xs={24}>
          <Form.Item
            label="Telefonnummer"
            name="companyContactTelephone"
            rules={[
              {
                required: true,
                message: "Skriv inn telefonnummer",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col md={8} sm={24} xs={24}>
          <Form.Item
            label="E-postadresse"
            name="companyContactEmail"
            rules={[
              {
                required: true,
                message: "Skriv inn E-postadresse",
              },
              { type: "email", message: "Skriv inn en gyldig epostadresse" },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col md={8} sm={24} xs={24}>
          <Form.Item label="Stilling" name="position">
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Title level={5}>Bedrift</Title>
      <Row gutter={24}>
        <Col md={12} sm={24} xs={24}>
          <Form.Item label="Nettside" name="url">
            <Input addonBefore="https://" />
          </Form.Item>
        </Col>
        <Col md={12} sm={12} xs={24}>
          <Form.Item
            label="Organisasjonsnummer"
            name="organization_number"
            rules={[
              {
                required: true,
                message: "Skriv inn organisasjonsnummer",
              },
              { pattern: new RegExp(/^[0-9]+$/), message: "Organisasjonsnummer må være tall" },
              { max: 9, min: 9, message: "Organisasjonsnummer må være 9 siffer langt" },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col md={12} sm={24} xs={24}>
          <Form.Item
            label="E-postadresse"
            name="email"
            rules={[{ type: "email", message: "Skriv inn en gyldig epostadresse" }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col md={12} sm={12} xs={24}>
          <Form.Item label="Telefonnummer" name="telephone">
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col md={12} sm={24} xs={24}>
          <Form.Item label="Postadresse" name="visitor_address">
            <Input />
          </Form.Item>
        </Col>
        <Col md={4} sm={12} xs={24}>
          <Form.Item label="Postnummer" name="visitor_area_code">
            <Input />
          </Form.Item>
        </Col>
        <Col md={4} sm={12} xs={24}>
          <Form.Item label="Poststed" name="visitor_region">
            <Input />
          </Form.Item>
        </Col>
        <Col md={4} sm={12} xs={24}>
          <Form.Item label="Land" name="country">
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};

export default CompanyContactInformation;
